import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Send, Inbox } from "lucide-react";
import { GmailInbox } from "./GmailInbox";

const SUBTABS = [
  { key: "received", label: "Received", icon: Inbox },
  { key: "sent", label: "Sent", icon: Send },
];

export function EmailCenter({ role }) {
  const [sub, setSub] = useState("received");
  return (
    <div data-testid="admin-email-center">
      <div className="flex gap-1 mb-6 border border-[#E5E7EB] bg-white w-fit p-1">
        {SUBTABS.map(({ key, label, icon: Icon }) => (
          <button key={key} data-testid={`email-subtab-${key}`} onClick={() => setSub(key)}
            className={`px-4 py-2 text-xs font-bold uppercase tracking-widest inline-flex items-center gap-2 ${sub === key ? "bg-[#C79A3B] text-white" : "text-[#6B7280] hover:text-[#12263A]"}`}>
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>
      {sub === "received" && <GmailInbox />}
      {sub === "sent" && <LogSection direction="outbound" />}
    </div>
  );
}

function LogSection({ direction }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get(`/admin/email-log?direction=${direction}`).then(r => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, [direction]);

  if (loading) return <div className="text-[#6B7280] text-sm">Loading…</div>;

  return (
    <div className="overflow-x-auto border border-[#E5E7EB] bg-white" data-testid={`email-log-${direction}`}>
      <table className="w-full text-sm">
        <thead className="bg-[#F4F4F4] text-left">
          <tr>{["To", "Subject", "Type", "Status", "When"].map(h => <th key={h} className="px-3 py-2 text-xs uppercase tracking-wider">{h}</th>)}</tr>
        </thead>
        <tbody>
          {items.map(e => (
            <tr key={e.id} data-testid={`email-log-row-${e.id}`} className="border-t border-[#E5E7EB]">
              <td className="px-3 py-2">{e.to}</td>
              <td className="px-3 py-2">{e.subject}</td>
              <td className="px-3 py-2 text-xs"><span className="bg-[#F4F4F4] border border-[#E5E7EB] px-2 py-0.5 rounded-full">{(e.kind || "email").replace(/_/g, " ")}</span></td>
              <td className="px-3 py-2 text-xs">{(e.status === "sent" || e.sent === true) ? <span className="text-green-700 font-semibold">Sent</span> : <span className="text-red-600 font-semibold">Failed</span>}</td>
              <td className="px-3 py-2 text-xs text-[#6B7280]">{new Date(e.created_at).toLocaleString("en-GB")}</td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-[#6B7280]">No emails logged yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
